module.exports = __webpack_public_path__ + "img/img_brand9.0a940a41.jpg";